import { render, staticRenderFns } from "./MyMenus.vue?vue&type=template&id=6e9a46c6&scoped=true&"
import script from "./MyMenus.vue?vue&type=script&lang=js&"
export * from "./MyMenus.vue?vue&type=script&lang=js&"
import style0 from "./MyMenus.vue?vue&type=style&index=0&id=6e9a46c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9a46c6",
  null
  
)

export default component.exports